/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class SupplementApply extends Ce {
    constructor() {
        super();
        this.baseUrl += '/supplementApply';
    }

    findSupplementApplyList(queryData) {
        let applyTimeBegin = null;
        let applyTimeEnd = null;
        if (queryData.applyTime != null && queryData.applyTime.length === 2) {
            [applyTimeBegin, applyTimeEnd] = queryData.applyTime;
        }
        return super.get('/findSupplementApplyList', {
            ...queryData,
            applyTimeBegin,
            applyTimeEnd,
        });
    }

    getSupplementApplyDetail({ id }) {
        return super.get('/getSupplementApplyDetail', { id });
    }

    submit({ id, applyStatus, auditOpinion, notPassIds } = {}) {
        return super.post('/submit', {
            id,
            applyStatus,
            auditOpinion,
            notPassIds,
        });
    }

    cancel({ id } = {}) {
        return super.post('/cancel', {
            id,
        });
    }

    editDeliveryInfo({
        id,
        shipMethod,
        deliveryConsignee,
        deliveryPhone,
        deliveryRegionId,
        deliveryAddress,
        companyName,
        workRegionId,
    }) {
        return super.post('/editDeliveryInfo', {
            id,
            shipMethod,
            deliveryConsignee,
            deliveryPhone,
            deliveryRegionId,
            deliveryAddress,
            companyName,
            workRegionId,
        });
    }

    relatedGrouping({ ids, supplementGroupingId } = {}) {
        return super.post('/relatedGrouping', {
            ids,
            supplementGroupingId,
        });
    }

    transferGrouping({ ids, supplementGroupingId, oldSupplementGroupingId } = {}) {
        return super.post('/transferGrouping', {
            ids,
            supplementGroupingId,
            oldSupplementGroupingId,
        });
    }

    batchSetMaterialsTimeout({ supplementGroupingId, ids, materialsIds }) {
        return super.post('/batchSetMaterialsTimeout', { supplementGroupingId, ids, materialsIds });
    }

    addRemarks({ supplementApplyId, remarks }) {
        return super.post('/addRemarks', { supplementApplyId, remarks });
    }
}

export default new SupplementApply();
export { SupplementApply };
